<div>
  <button
    [class]="buttonClass()"
    [class.button--disabled]="!_enabled()"
    [class.loading]="loading()"
    (click)="onClickButton($event)"
  >
    <svg-icon src="assets/images/icons/loader.svg" class="button__loader"></svg-icon>
    <ng-content></ng-content>
  </button>
</div>
